(() => {
  const PHONE_SELECTOR = 'input[data-fw-phone]';
  const FORM_SELECTOR = '[data-fw-intake-form]';

  const normalizeDigits = (value) => {
    let digits = String(value || '').replace(/\D/g, '');

    if (
      digits.length === 11 &&
      digits.startsWith('1')
    ) {
      digits = digits.slice(1);
    }

    return digits.slice(0, 10);
  };

  const formatPhone = (value) => {
    const digits = normalizeDigits(value);

    if (!digits) {
      return '';
    }

    if (digits.length < 3) {
      return `(${digits}`;
    }

    if (digits.length === 3) {
      return `(${digits})`;
    }

    if (digits.length <= 6) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    }

    return (
      `(${digits.slice(0, 3)}) ` +
      `${digits.slice(3, 6)}-` +
      `${digits.slice(6)}`
    );
  };

  const setInvalid = (field, invalid) => {
    if (!field) return;

    field.classList.toggle(
      'is-invalid',
      invalid
    );

    if (invalid) {
      field.setAttribute(
        'aria-invalid',
        'true'
      );
    } else {
      field.removeAttribute(
        'aria-invalid'
      );
    }
  };

  const getLabel = (field) => {
    return (
      field.dataset.fwLabel ||
      field.name ||
      'Phone'
    );
  };

  const showFormError = (
    form,
    field,
    message
  ) => {
    const summary =
      form.querySelector(
        '[data-fw-validation-summary]'
      );

    const list =
      form.querySelector(
        '[data-fw-validation-list]'
      );

    if (
      summary &&
      list
    ) {
      list.innerHTML = '';

      const item =
        document.createElement('li');

      item.textContent = message;

      list.appendChild(item);

      summary.hidden = false;
    }

    setInvalid(field, true);

    field.focus();
  };

  const clearFieldError = (field) => {
    setInvalid(field, false);
  };

  const initPhoneField = (field) => {
    if (
      field.dataset.fwPhoneFormatterReady ===
      'true'
    ) {
      return;
    }

    field.dataset.fwPhoneFormatterReady =
      'true';

    field.value =
      formatPhone(field.value);

    field.addEventListener(
      'input',
      () => {
        field.value =
          formatPhone(field.value);

        clearFieldError(field);
      }
    );

    field.addEventListener(
      'blur',
      () => {
        field.value =
          formatPhone(field.value);
      }
    );
  };

  const initWithin = (
    scope = document
  ) => {
    if (
      scope.matches?.(
        PHONE_SELECTOR
      )
    ) {
      initPhoneField(scope);
    }

    scope
      .querySelectorAll?.(
        PHONE_SELECTOR
      )
      .forEach(initPhoneField);
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form =
        event.target.closest?.(
          FORM_SELECTOR
        );

      if (!form) return;

      const phoneFields =
        form.querySelectorAll(
          PHONE_SELECTOR
        );

      for (
        const field of phoneFields
      ) {
        const value =
          field.value.trim();

        if (!value) {
          continue;
        }

        const digits =
          normalizeDigits(value);

        if (
          digits.length !== 10
        ) {
          event.preventDefault();
          event.stopImmediatePropagation();

          showFormError(
            form,
            field,
            `${getLabel(field)} must contain a 10-digit phone number.`
          );

          return;
        }

        field.value =
          formatPhone(value);
      }
    },
    true
  );

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => initWithin(),
      { once: true }
    );
  } else {
    initWithin();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initWithin(event.target);
    }
  );
})();